export const FETCH_STAFF_MEMBER_INFO_REQUEST = 'FETCH_STAFF_MEMBER_INFO_REQUEST'
export const FETCH_STAFF_MEMBER_INFO_SUCCESS = 'FETCH_STAFF_MEMBER_INFO_SUCCESS'
export const FETCH_STAFF_MEMBER_INFO_FAIL = 'FETCH_STAFF_MEMBER_INFO_FAIL'

export const EDIT_STAFF_MEMBER_INFO_FAIL = 'EDIT_STAFF_MEMBER_INFO_FAIL'
export const EDIT_STAFF_MEMBER_INFO_SUCCESS = 'EDIT_STAFF_MEMBER_INFO_SUCCESS'
export const EDIT_STAFF_MEMBER_INFO_REQUEST = 'EDIT_STAFF_MEMBER_INFO_REQUEST'
export const EDIT_STAFF_MEMBER_INFO_RESET = 'EDIT_STAFF_MEMBER_INFO_RESET'

